<template>
  <transition name="slide-fade">
    <div class="loading-data" v-if="loading">
      <i class="el-icon-loading"></i>
      <div>加载中，请稍后···</div>
    </div>
    <div class="single-approval" v-if="hide && !loading">
      <div class="look-nav">
        <div class="handle-wrapper" @click="backPath">
          <div class="icon-font">&#xe612;</div>
          返回
        </div>
        <div class="look-nav-center">{{ statusValue.materialName }}</div>
        <div class="handle-wrapper" @click="handleData">
          <div class="icon-font">&#xe678;</div>
          提交
        </div>
      </div>
      <div class="single-approval-content">
        <div class="single-approval-content-list">
          <div class="input-contain">
            <div class="input-title" style="padding-left: 1.72vw">
              物料代码：
            </div>
            <div class="input-wrapper" style="padding: 0.63vw">
              <div
                class="popover"
                style="text-align: left"
                v-if="statusValue && statusValue.materialCode.length < 18"
              >
                {{ statusValue && statusValue.materialCode }}
              </div>
              <div
                class="detail-item"
                style="width: 100%; display: block"
                v-if="statusValue && statusValue.materialCode.length >= 18"
              >
                <el-popover
                  placement="top"
                  title=""
                  trigger="hover"
                  :content="statusValue && statusValue.materialCode"
                >
                  <div class="popover" slot="reference">
                    {{ statusValue && statusValue.materialCode }}
                  </div>
                </el-popover>
              </div>
            </div>
          </div>
          <div class="input-contain">
            <div class="input-title" style="padding-left: 1.78vw">
              烟叶简称：
            </div>
            <div class="input-wrapper">
              <input
                disabled="true"
                v-model="statusValue.materialName"
                placeholder=""
              />
            </div>
          </div>
          <div class="input-contain">
            <div class="input-title" style="padding-left: 1.67vw">
              烟叶年份：
            </div>
            <div class="input-wrapper">
              <input
                placeholder=""
                disabled="true"
                v-model="statusValue.year"
              />
            </div>
          </div>
          <div class="input-contain">
            <div class="input-title" style="padding-left: 3.56vw">库龄：</div>
            <div class="input-wrapper">
              <input disabled="true" placeholder="" v-model="statusValue.age" />
              <div class="input-suffix">(天)</div>
            </div>
          </div>
        </div>
        <div class="single-approval-content-list">
          <div class="input-contain">
            <div class="input-title" style="padding-left: 1.78vw">
              仓库位置：
            </div>
            <div class="input-wrapper">
              <input v-model="statusValue.siteName" placeholder="" />
            </div>
          </div>
          <div class="input-contain">
            <div class="input-title" style="padding-left: 2.67vw">负责人：</div>
            <div class="input-wrapper">
              <input
                placeholder=""
                disabled="true"
                v-model="statusValue.principalName"
              />
            </div>
          </div>
          <div class="input-contain">
            <div class="input-title" style="padding-left: 1.78vw">
              申请日期：
            </div>
            <div class="input-suffix-wrapper">
              <el-date-picker
                :disabled="true"
                v-model="statusValue.createdTime"
                type="date"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="input-contain">
            <div class="input-title" style="padding-left: 1.78vw">
              申请编号：
            </div>
            <div class="input-wrapper">
              <input
                placeholder=""
                disabled="true"
                v-model="statusValue.applyNum"
              />
            </div>
          </div>
        </div>
        <div class="single-approval-content-list">
          <div class="input-contain">
            <div class="input-title" style="padding-left: 1.78vw">
              养护阶段：
            </div>
            <div class="input-wrapper">
              <input
                placeholder=""
                disabled="true"
                v-model="statusValue.maintainStage"
              />
            </div>
          </div>
          <div class="input-contain">
            <div class="input-title" style="padding-left: 1.78vw">
              养护天数：
            </div>
            <div class="input-wrapper">
              <input
                disabled="true"
                placeholder=""
                v-model="statusValue.maintainDays"
              />
              <div class="input-suffix">(天)</div>
            </div>
          </div>
          <div class="input-contain">
            <div class="input-title" style="padding-left: 1.78vw">
              调养日期：
            </div>
            <div class="input-suffix-wrapper">
              <el-date-picker
                :disabled="true"
                v-model="statusValue.aftercareDateStart"
                type="date"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="input-contain">
            <div class="input-title">降氧完成时间：</div>
            <div class="input-wrapper">
              <input
                disabled="true"
                placeholder=""
                v-model="statusValue.oxygenReductionDays"
              />
              <div class="input-suffix">(天)</div>
            </div>
          </div>
        </div>
        <div class="single-approval-content-list">
          <div class="input-contain">
            <div class="input-title" style="padding-left: 1.78vw">
              养护数量：
            </div>
            <div class="input-wrapper">
              <input
                placeholder=""
                disabled="true"
                v-model="statusValue.maintainCount"
              />
              <div class="input-suffix">(担)</div>
            </div>
          </div>
          <div class="input-contain">
            <div class="input-title" style="padding-left: 1.67vw">
              到期时间：
            </div>
            <div class="input-wrapper">
              <input
                disabled="true"
                v-model="statusValue.expireTime"
                placeholder=""
              />
            </div>
          </div>
           <div class="input-contain" style="opacity: 0;">
              <div class="input-title" style="padding-left: 1.67vw">到期时间：</div>
              <div class="input-wrapper">
               <input disabled="true" />
              </div>
            </div>
            <div class="input-contain" style="opacity: 0;">
              <div class="input-title" style="padding-left: 1.67vw">到期时间：</div>
              <div class="input-wrapper">
               <input disabled="true" />
              </div>
            </div>
        </div>
        <div class="single-look-content-list">
          <div class="input-contain">
            <div class="input-title">包芯水分下限：</div>
            <div class="input-suffix-wrapper">
              <input
                disabled="true"
                v-model="statusValue.maintainStageData.wetCoreChipLower"
                placeholder=""
              />
              <div class="input-suffix">（%）</div>
            </div>
          </div>
          <div class="input-contain">
            <div class="input-title">包芯水分上限：</div>
            <div class="input-suffix-wrapper">
              <input
                disabled="true"
                v-model="statusValue.maintainStageData.wetCoreChipUpper"
                placeholder=""
              />
              <div class="input-suffix">（%）</div>
            </div>
          </div>
          <div class="input-contain">
            <div class="input-title">包芯温度上限：</div>
            <div class="input-suffix-wrapper">
              <input
                disabled="true"
                v-model="statusValue.maintainStageData.tempCoreChipUpper"
                placeholder=""
              />
              <div class="input-suffix">（℃）</div>
            </div>
          </div>
          <div class="input-contain">
            <div class="input-title">包芯温度下限：</div>
            <div class="input-suffix-wrapper">
              <input
                disabled="true"
                v-model="statusValue.maintainStageData.tempCoreChipLower"
                placeholder=""
              />
              <div class="input-suffix">（℃）</div>
            </div>
          </div>
        </div>
        <div class="single-look-content-list">
          <div class="input-contain">
            <div class="input-title" style="padding-left: 0.2vw">
              CO₂浓度上限：
            </div>
            <div class="input-suffix-wrapper">
              <input
                disabled="true"
                v-model="statusValue.maintainStageData.concentrationCo2Upper"
                placeholder=""
              />
              <div class="input-suffix">（PPM）</div>
            </div>
          </div>
          <div class="input-contain">
            <div class="input-title" style="padding-left: 0.15vw">
              CO₂浓度下限：
            </div>
            <div class="input-suffix-wrapper">
              <input
                disabled="true"
                v-model="statusValue.maintainStageData.concentrationCo2Lower"
                placeholder=""
              />
              <div class="input-suffix">（PPM）</div>
            </div>
          </div>
          <div class="input-contain">
            <div class="input-title">垛内温度上限：</div>
            <div class="input-suffix-wrapper">
              <input
                disabled="true"
                v-model="statusValue.maintainStageData.stackTempUpper"
                placeholder=""
              />
              <div class="input-suffix">（℃）</div>
            </div>
          </div>
          <div class="input-contain">
            <div class="input-title">垛内温度下限：</div>
            <div class="input-suffix-wrapper">
              <input
                disabled="true"
                v-model="statusValue.maintainStageData.stackTempLower"
                placeholder=""
              />
              <div class="input-suffix">（℃）</div>
            </div>
          </div>
        </div>
        <div class="single-look-content-list">
          <div class="input-contain">
            <div class="input-title">垛内湿度上限：</div>
            <div class="input-suffix-wrapper">
              <input
                disabled="true"
                v-model="statusValue.maintainStageData.stackMoistureUpper"
                placeholder=""
              />
              <div class="input-suffix">（%）</div>
            </div>
          </div>
          <div class="input-contain">
            <div class="input-title">垛内湿度下限：</div>
            <div class="input-suffix-wrapper">
              <input
                disabled="true"
                v-model="statusValue.maintainStageData.stackMoistureLower"
                placeholder=""
              />
              <div class="input-suffix">（%）</div>
            </div>
          </div>
          <div class="input-contain">
            <div class="input-title" style="padding-left: 0.75vw">
              O₂浓度上限：
            </div>
            <div class="input-suffix-wrapper">
              <input
                disabled="true"
                v-model="statusValue.maintainStageData.oxygenUpper"
                placeholder=""
              />
              <div class="input-suffix">（%）</div>
            </div>
          </div>
          <div class="input-contain">
            <div class="input-title" style="padding-left: 0.75vw">
              O₂浓度下限：
            </div>
            <div class="input-suffix-wrapper">
              <input
                disabled="true"
                v-model="statusValue.maintainStageData.oxygenLower"
                placeholder=""
              />
              <div class="input-suffix">（%）</div>
            </div>
          </div>
        </div>
        <div class="text-area-wrapper">
          <div class="text-area-title" style="padding-left: 3.56vw">备注：</div>
          <textarea
            v-model="statusValue.remark"
            disabled
            rows="1"
            class="text-area-input"
          ></textarea>
        </div>
      </div>
      <div class="single-approval-content-b">
        <div class="single-approval-content-list">
          <!--          <div class="input-contain">-->
          <!--            <div class="input-title" style="padding-left: 2.67vw">审批人：</div>-->
          <!--            <DropDownInput type="1" :items="custodianValue" :content="inputValue.principalName" @sendValue="sendValue" @sendInfo="showInfo"></DropDownInput>-->
          <!--          </div>-->
          <div class="input-contain">
            <div class="input-title" style="padding-left: 1.78vw">
              审核状态：
            </div>
            <DropDown
              content="请选择审核状态"
              :items="statusData"
              v-on:sendInfo="showInfoStatusData"
            ></DropDown>
          </div>
        </div>
        <div class="text-area-wrapper">
          <div class="text-area-title" style="padding-left: 3.56vw">备注：</div>
          <textarea
            v-model="inputValue.approverOpinion"
            rows="1"
            class="text-area-input"
          ></textarea>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { detailMaintainPlan, checkMaintainPlan } from "../../../api/maintain";
import { userList } from "../../../api/system";
import { daysDistance, renderTime } from "../../../tools/methods";
import DropDownInput from "../../../components/DropDownInput.vue";
import DropDown from "../../../components/DropDownSingle.vue";
export default {
  name: "SingleApproval",
  components: { DropDownInput, DropDown },
  data() {
    return {
      loading: true,
      hide: false,
      custodianValue: [],
      statusValue: "",
      statusData: [
        { name: "通过", value: 1 },
        { name: "拒绝", value: 2 },
      ],
      inputValue: {
        id: "",
        approverId: "",
        approverName: "",
        approverOpinion: "",
        approveStatus: "",
      },
    };
  },
  created() {
    let _this = this;
    setInterval(function () {
      _this.hide = true;
    }, 100);
    let id = this.$route.query.id;
    detailMaintainPlan({ id: id })
      .then((res) => {
        console.log(res);
        this.statusValue = res.data;
        this.inputValue.id = res.data.id;
        this.statusValue.expireTime = renderTime(res.data.expireTime);
        this.statusValue.age = daysDistance(res.data.warehouseBuildTime);
        this.loading = false;
      })
      .catch((err) => {
        console.log(err);
      });
    this.handleSearchValue();
  },
  methods: {
    showInfoStatusData: function (data) {
      this.inputValue.approveStatus = data.value;
    },
    backPath: function () {
      this.$router.go(-1);
    },
    showInfo: function (data) {
      console.log(data);
      this.inputValue.approverId = data.id;
      this.inputValue.approverName = data.name;
    },
    sendValue: function (value) {
      this.handleSearchValue(value);
    },
    handleSearchValue: function (value) {
      let body = {
        keywork: value,
        page: 1,
        rows: 9999,
      };
      userList(body)
        .then((res) => {
          this.custodianValue = res.data.rows;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleData: function () {
      checkMaintainPlan(this.inputValue)
        .then((res) => {
          console.log(res);
          if (res.code === 200) {
            this.$message({
              message: res.data,
              type: "warning",
              center: "true",
              duration: "1000",
            });
          } else {
            this.$message({
              message: res.message,
              type: "warning",
              center: "true",
              duration: "1000",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
@import "Conserve.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/conserve/SingleApproval.vue